import { onMounted, ref, watch } from 'vue';
import useFetch from '@/composables/useFetch';

export default function useCountries(url, config) {
  const fetchData = useFetch();

  // eslint-disable-next-line
  const _countries = ref(null);
  const countriesToDisplay = ref(null);
  const loading = ref(false);
  const error = ref(null);
  // eslint-disable-next-line
  const numberOfCountriesToDisplay = ref(null);

  const filterByRegion = async (regionName) => {
    loading.value = true;
    error.value = null;
    const { fetchResult, fetchError } = await fetchData(`https://restcountries.eu/rest/v2/region/${regionName}`);

    if (!fetchError.value) {
      _countries.value = fetchResult.value;

      if (config.lazy ?? false) {
        numberOfCountriesToDisplay.value = 30;
      }
    } else error.value = fetchError.value;

    loading.value = false;
  };

  watch([_countries, numberOfCountriesToDisplay], (newValues) => {
    const [, newNumOfCountriesToDisplay] = newValues;
    const arrlength = _countries.value.length;
    if (error.value) return;

    if (arrlength < newNumOfCountriesToDisplay) {
      countriesToDisplay.value = _countries.value;
    } else {
      countriesToDisplay.value = _countries.value.slice(0, newNumOfCountriesToDisplay);
    }
  });

  onMounted(async () => {
    loading.value = true;
    error.value = null;

    const { fetchResult, fetchError } = await fetchData(url);

    if (!fetchError.value) {
      _countries.value = fetchResult.value;

      if (config.lazy ?? false) {
        numberOfCountriesToDisplay.value = 30;
      }
    } else error.value = fetchError.value;

    loading.value = false;
  });

  return {
    countriesToDisplay,
    loading,
    error,
    filterByRegion,
    numberOfCountriesToDisplay,
  };
}
